import { jsxs, jsx } from "react/jsx-runtime";
const UnknownErrorIcon = () => /* @__PURE__ */ jsxs("svg", { width: "200", height: "200", viewBox: "0 0 200 200", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M172.647 85.1731L123.831 138.633C120.984 141.723 122.265 147.131 126.25 148.212L193.284 167.526C197.269 168.607 200.827 164.745 199.831 160.418L181.613 87.7998C180.333 83.4736 175.494 81.9285 172.647 85.1731Z",
      fill: "url(#paint0_linear_305_108784)"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M30.6096 24.6061L1.57591 93.0531C-0.131957 97.0703 2.85681 101.551 6.84183 101.242L75.868 94.2891C79.9954 93.8256 82.1302 88.8814 79.7107 85.1732L39.7182 23.6791C37.2987 19.9709 32.3175 20.5889 30.6096 24.6061Z",
      fill: "url(#paint1_linear_305_108784)"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M85.8307 34.1856L2.00298 169.071C-2.97829 176.951 1.86066 187.766 10.6846 188.539L160.265 199.972C169.089 200.59 175.209 190.702 171.366 182.05L105.613 35.7307C101.771 27.0782 90.812 26.3057 85.8307 34.1856Z",
      fill: "#ED6C47"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M88.6771 143.886C85.546 143.577 83.1266 140.641 83.4112 137.242L87.5385 74.0486C87.8232 70.6494 90.5273 68.0228 93.6584 68.3318C96.7895 68.6408 99.2089 71.5765 98.9243 74.9757L94.797 138.169C94.5123 141.569 91.8082 144.041 88.6771 143.886Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M87.8232 165.517C91.3603 165.517 94.2277 162.404 94.2277 158.564C94.2277 154.724 91.3603 151.612 87.8232 151.612C84.2861 151.612 81.4187 154.724 81.4187 158.564C81.4187 162.404 84.2861 165.517 87.8232 165.517Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M23.3514 67.5593C20.3627 68.4863 17.2316 66.6322 16.3776 63.2331L4.70723 18.5803C3.8533 15.3357 5.56116 11.9365 8.69225 11.0094C11.681 10.0824 14.8121 11.9365 15.666 15.3357L27.3364 59.9884C28.0481 63.2331 26.3402 66.6322 23.3514 67.5593Z",
      fill: "#28C2D1"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M27.0516 88.7268C30.5887 88.7268 33.4561 85.6139 33.4561 81.774C33.4561 77.934 30.5887 74.8211 27.0516 74.8211C23.5145 74.8211 20.6471 77.934 20.6471 81.774C20.6471 85.6139 23.5145 88.7268 27.0516 88.7268Z",
      fill: "#28C2D1"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M179.194 121.482C176.205 120.555 174.497 117.002 175.351 113.757L187.591 69.4134C188.445 66.1687 191.718 64.3146 194.707 65.2417C197.696 66.1687 199.404 69.7224 198.55 72.967L186.168 117.465C185.314 120.71 182.183 122.564 179.194 121.482Z",
      fill: "#F7937C"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M175.209 142.65C178.746 142.65 181.614 139.537 181.614 135.697C181.614 131.857 178.746 128.744 175.209 128.744C171.672 128.744 168.805 131.857 168.805 135.697C168.805 139.537 171.672 142.65 175.209 142.65Z",
      fill: "#F7937C"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M23.3514 67.5593C20.3627 68.4863 17.2316 66.6322 16.3776 63.2331L4.70723 18.5803C3.8533 15.3357 5.56116 11.9365 8.69225 11.0094C11.681 10.0824 14.8121 11.9365 15.666 15.3357L27.3364 59.9884C28.0481 63.2331 26.3402 66.6322 23.3514 67.5593Z",
      fill: "#F7937C"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M27.0516 88.7268C30.5887 88.7268 33.4561 85.6139 33.4561 81.774C33.4561 77.934 30.5887 74.8211 27.0516 74.8211C23.5145 74.8211 20.6471 77.934 20.6471 81.774C20.6471 85.6139 23.5145 88.7268 27.0516 88.7268Z",
      fill: "#F7937C"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M109.883 17.6533C109.029 19.1983 109.314 21.0524 110.452 22.2885C110.595 22.443 110.879 22.752 111.164 22.752C112.872 23.8336 115.007 23.2155 115.861 21.5159L120.273 13.4815C120.7 12.5545 120.842 11.6275 120.7 10.5459C120.557 9.77336 120.13 9.00082 119.561 8.5373C119.419 8.38279 119.276 8.38279 119.134 8.22828C117.426 7.14673 115.291 7.76476 114.437 9.46434L109.883 17.6533Z",
      fill: "#E1DFDD"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M123.404 34.8036C123.546 35.1126 123.831 35.5761 124.115 35.8852C125.254 36.9667 126.819 37.2757 128.1 36.5032L135.501 32.486C136.355 32.0225 136.924 31.2499 137.209 30.3229C137.494 29.3958 137.494 28.3143 137.067 27.3872C136.782 26.9237 136.497 26.4602 136.07 26.1512C135.786 25.8422 135.359 25.6877 135.074 25.5331C134.22 25.2241 133.224 25.2241 132.37 25.6877L124.969 29.7049C124.115 30.1684 123.546 30.9409 123.261 31.868C122.977 32.9495 122.977 33.8766 123.404 34.8036Z",
      fill: "#E1DFDD"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M92.5199 14.2541C92.6622 15.0266 92.9469 15.7992 93.5161 16.4172C94.2278 17.1897 95.3663 17.6533 96.3626 17.4988C98.2128 17.1897 99.636 15.3356 99.3513 13.1725L98.0704 3.28404C97.9281 2.35699 97.5012 1.42994 96.7895 0.811913C96.0779 0.193882 95.0817 -0.115134 94.0854 0.0393738C92.2352 0.348389 90.812 2.20248 91.0967 4.36559L92.5199 14.2541Z",
      fill: "#E1DFDD"
    }
  ),
  /* @__PURE__ */ jsxs("defs", { children: [
    /* @__PURE__ */ jsxs(
      "linearGradient",
      {
        id: "paint0_linear_305_108784",
        x1: "119.427",
        y1: "140.444",
        x2: "172.545",
        y2: "130.261",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ jsx("stop", { offset: "0.000984252", stopColor: "#C8C6C4" }),
          /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#E1DFDD" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      "linearGradient",
      {
        id: "paint1_linear_305_108784",
        x1: "75.0053",
        y1: "96.3245",
        x2: "33.8947",
        y2: "73.659",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ jsx("stop", { offset: "0.000984252", stopColor: "#C8C6C4" }),
          /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#E1DFDD" })
        ]
      }
    )
  ] })
] });
export {
  UnknownErrorIcon
};
//# sourceMappingURL=UnknownErrorIcon.js.map
